import Image from 'next/image';
import ButtonLink from '@/components/ui/ButtonLink';
import Text from '@/components/ui/Text';

const ServiceCard = ({ service, locale }: ServiceCardProps) => {
  const { title, summary, image, slug, buttonText } = service;
  const href = `/${locale}/servicos/${slug}`;

  return (
    <article className="relative h-full flex flex-col group">
      <div
        data-carousel-media
        className="relative w-full overflow-hidden rounded-xs aspect-[4/5]"
      >
        <div className="absolute inset-0 transition-transform duration-500 ease-out group-hover:scale-105">
          <Image
            src={image?.url}
            alt={image?.alt}
            fill
            sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
            className="object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-500" />
      </div>

      <div className="flex flex-col flex-1 pt-3 desktop:pt-5">
        <Text as="h3" variant="cardTitle">
          {title}
        </Text>

        {summary && (
          <Text
            as="p"
            variant="paragraph"
            className="mt-2 overflow-hidden [display:-webkit-box] [-webkit-line-clamp:3] [-webkit-box-orient:vertical]"
          >
            {summary}
          </Text>
        )}

        {buttonText && (
          <div className="mt-auto desktop:pt-4">
            <ButtonLink
              href={href}
              variant="text"
              arrow
              className="after:absolute after:inset-0"
            >
              {buttonText}
              <span className="sr-only"> {title}</span>
            </ButtonLink>
          </div>
        )}
      </div>
    </article>
  );
};

export default ServiceCard;

export type Service = {
  title: string;
  summary?: string;
  buttonText?: string;
  slug: string;
  image: {
    url: string;
    alt: string;
  };
};

type ServiceCardProps = {
  service: Service;
  locale: string;
};
